module.exports = __webpack_public_path__ + "img/weixin.0eb004ef.jpg";